import { create } from 'zustand';

interface SuggestionTabAlertsState {
  unseenCount: number;
  hasAttention: boolean;
}

interface SuggestionTabAlertsActions {
  setUnseen: (unseen: { count: number; hasAttention: boolean }) => void;
  reset: () => void;
}

const INITIAL_STATE: SuggestionTabAlertsState = {
  unseenCount: 0,
  hasAttention: false,
};

export const useSuggestionTabAlertsStore = create<
  SuggestionTabAlertsState & SuggestionTabAlertsActions
>((set) => ({
  ...INITIAL_STATE,
  setUnseen: ({ count, hasAttention }) =>
    set({ unseenCount: count, hasAttention }),
  reset: () => set(INITIAL_STATE),
}));
